import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      50: '#F0F8FF',
      100: '#E0F1FE',
      200: '#BBE3FC',
      300: '#7FCDFA',
      400: '#3BB5F5',
      500: '#119CE6',
      600: '#057CC4',
      700: '#05629F',
      800: '#095383',
      900: '#0D466D',
      main: '#119CE6',
      light: '#BBE3FC',
      dark: '#05629F',
    },
    text: {
      primary: '#333',
      secondary: 'rgba(0, 0, 0, 0.38)',
    },
    map: {
      red: '#FF5A49',
      green: '#00B13B',
      yellow: '#FFD700',
      default: '#726f6f',
      blue: '#6891FE',
      orange: '#FFB23F',
      olive: '#9dae11',
      darkGrey: '#444',
    },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif",
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          boxShadow: '0px 3px 12px 0px rgba(29, 29, 29, 0.04)',
          padding: '8px 12px',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '0',
          '&:last-child': {
            paddingBottom: '0',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          lineHeight: '24px',
          letterSpacing: '0.15px',
          borderRadius: '4px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-input': {
            padding: '8px 12px',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          transform: 'translate(14px, 8px) scale(1)',
          transition: 'all 0.2s ease-out',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -9px) scale(0.75)',
          },
        },
        filled: {
          transform: 'translate(14px, 8px) scale(1)',
          transition: 'all 0.2s ease-out',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(12px, 7px) scale(0.75)',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.MuiInputLabel-outlined': {
            transform: 'translate(14px, 8px) scale(1)',
            '&.MuiInputLabel-shrink': {
              transform: 'translate(14px, -9px) scale(0.75) !important',
            },
          },
          '&.MuiInputLabel-filled': {
            transform: 'translate(14px, 8px) scale(1)',
            '&.MuiInputLabel-shrink': {
              transform: 'translate(12px, 7px) scale(0.75) !important',
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          textTransform: 'none',
          boxShadow: 'none',
          fontWeight: 400,
        },
        containedPrimary: {
          backgroundColor: '#057CC4',
          color: '#fff',
          '&:hover': {
            color: '#fff',
            backgroundColor: '#05629F',
          },
        },
        outlinedPrimary: {
          borderColor: 'transparent',
          backgroundColor: 'transparent',
          color: '#057CC4',
          '&:hover': {
            borderColor: 'rgba(#057CC4, 0.04)',
            backgroundColor: 'rgba(#057CC4, 0.04)',
            color: '#05629F',
          },
        },
        textPrimary: {
          color: '#057CC4',
          '&:hover': {},
          textPrimary: {
            color: '#119CE6',
            '&:hover': {
              backgroundColor: 'rgba(17, 156, 230, 0.04)',
            },
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          color: '#333',
          backgroundColor: '#F9F9F9',
          fontSize: '16px',
          fontFamily: "'Roboto', sans-serif",
        },
      },
    },
  },
});

export default theme;
